import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/profile/actionTypes';
import { connectFacebook } from './utils';

export default function* listenFacebookConnect() {
  yield takeEvery(actionTypes.FACEBOOK_CONNECT, connectFacebook);
}
